import { useCallback, useContext } from "react"
import { NormalizerContext } from "../NormalizerContext"
import { useQueryClient } from "@tanstack/react-query"
import { checkTypes } from "keys/checkTypes"

const useSelectCheckType = () => {
    const { setLoadingData, checkType, setCheckType } = useContext(NormalizerContext)
    const queryClient = useQueryClient()

    const handleChangeCheckType = useCallback((val) => {
        // if (checkType)
        //     queryClient.removeQueries({ queryKey: [checkType.queryKey] })
        setCheckType(val)
        setLoadingData(true)
    }, [checkType])

    const selectCheckType = {
        options: checkTypes,
        onChange: handleChangeCheckType,
        input: {
            value: checkType,
        },
        placeholder: "תחום הבדיקה",
        border: true,
        width: 110,
        focus:true,
        component: "autoComplete"
    }

    return selectCheckType
}

export default useSelectCheckType